import { render, staticRenderFns } from "./IconScribd.vue?vue&type=template&id=4b5ff7f6&"
import script from "./IconScribd.vue?vue&type=script&lang=js&"
export * from "./IconScribd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports